import React, { useState } from "react";
import NetworkCube from "./network-cube";
import Base from "./base";

interface NetworkIconProps {
  scale?: number;
  borderColor?: string;
  nodeColor?: string;
  baseColor?: string;
  baseHighlightColor?: string;
  content?: React.ReactNode;
  isAnimating?: boolean;
}

export default function NetworkIcon({
  scale = 1,
  borderColor = "white",
  nodeColor = "#7fff00",
  baseColor = "#7fff00",
  baseHighlightColor = "#9fff00",
  content = <div>NIM</div>,
  isAnimating = false,
}: NetworkIconProps) {
  const [isCubeHovered, setIsCubeHovered] = useState(false);
  const [isBaseHovered, setIsBaseHovered] = useState(false);

  // The base should move down if either the cube or base is hovered, or if we're animating
  const shouldMoveBaseDown = isCubeHovered || isBaseHovered || isAnimating;

  // Calculate dimensions based on scale
  const width = 250 * scale;
  const height = 300 * scale;

  // Calculate polygon points based on scale
  const basePolygonPoints = [
    [70, 200],
    [150, 250],
    [230, 200],
    [230, 220],
    [150, 270],
    [70, 220],
  ]
    .map(([x, y]) => [x * scale, y * scale])
    .map(([x, y]) => `${x},${y}`)
    .join(" ");

  return (
    <svg
      id="network-svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background */}
      <rect width={width} height={height} fill="transparent" />

      {/* Interactive group for the cube */}
      <g
        transform={`translate(${150 * scale}, ${130 * scale}) scale(${scale})`}
        onMouseEnter={() => setIsCubeHovered(true)}
        onMouseLeave={() => setIsCubeHovered(false)}
        style={{ cursor: "pointer" }}
      >
        <NetworkCube
          isHovered={isCubeHovered}
          borderColor={borderColor}
          nodeColor={nodeColor}
          content={content}
          isAnimating={isAnimating}
        />
      </g>

      {/* Hover detection area for the base - positioned to match the green base shape */}
      <polygon
        points={basePolygonPoints}
        fill="transparent"
        onMouseEnter={() => setIsBaseHovered(true)}
        onMouseLeave={() => setIsBaseHovered(false)}
        style={{ cursor: "pointer" }}
      />

      {/* The green base that moves when either the cube or base is hovered */}
      <g
        transform={`translate(${150 * scale}, ${
          (shouldMoveBaseDown ? 180 : 140) * scale
        }) scale(${scale})`}
        style={{ transition: "transform 0.5s ease-in-out" }}
      >
        <Base baseColor={baseColor} baseHighlightColor={baseHighlightColor} />
      </g>
    </svg>
  );
}
